// extracted by mini-css-extract-plugin
export default {"MiddleRow":"Allfeed_MiddleRow__O0eXr"};